// extracted by mini-css-extract-plugin
export var fadeInOut = "_3u-3";
export var icon = "_3u-4";
export var savedIndicator = "_3u-2";
export var savingIndicator = "_3u-0";
export var spin = "_3u-1";